import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

/**
 * A component used to add auth related info like terms of services and copy rights on top of the footer in auth related pages
 *
 * @returns {JSX.Element}
 */

export default function AuthFooter() {
  const { t } = useTranslation("global");

  return (
    <footer className="relative z-10">
      <div>
        <div className="my-5 lg:my-2">
          <ul className="flex flex-row justify-center items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
            {/* <li>
                <a
                  href="/privacy-policy"
                  className="text-background_steel_blue hover:underline me-4 md:me-6"
                >
                  {t("footer.items_2.privacy_text")}
                </a>
              </li> */}
            <li>
              <a
                href="/terms-condition"
                className="text-background_steel_blue hover:underline me-4 md:me-6"
                target="_blank"
              >
                {t("footer.items_2.terms_text")}
              </a>
            </li>
            {/* <li>
                <button
                  onClick={() => console.log("Cookies Settings clicked")}
                  className="text-background_steel_blue hover:underline me-4 md:me-6 bg-transparent border-none cursor-pointer"
                >
                  {t("footer.items_2.cookies_text")}
                </button>
              </li> */}
          </ul>
        </div>
        <span className="block text-sm text-gray-500 text-center dark:text-gray-400">
          {t("copy_rights_text")} <NavLink to="/">{t("amk_text")} </NavLink>
          {t("or_affiliates_text")}
        </span>
      </div>
    </footer>
  );
}
